export default "__VITE_ASSET__BMdOiJGC__ 100w";